import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxMarkableAsReadFeatureState as State} from '../../../@interfaces';
import {MARK_COMMENT_AS_READ} from './constants';

const reducer: Reducer = (state: State = initialState, action: IReduxAction): State => {
    switch (action.type) {
        case MARK_COMMENT_AS_READ:
            return {
                ...state,
                readCommentsIds: {
                    ...state.readCommentsIds,
                    [action.payload]: Date.now(),
                }
            };

        default:
            break;
    }

    return state;
};

export default reducer;
